function select() {
  formDrop();
}
function formDrop() {
  selectInit('select:not(.wpforms-container select)');
}
function selectInit(selector) {
  jQuery(selector).each(function () {
    var $this = jQuery(this);
    var numberOfOptions = jQuery(this).children('option').length;
    var selectedInput = false;
    var selectOptions = null;
    $this.addClass('select-hidden');
    $this.wrap('<div class="js-select"></div>');
    $this.after('<div class="select-input"></div>');
    var $styledSelect = $this.next('div.select-input');
    var $selectedInputText = jQuery('<span class="select-input__text"></span>');
    $selectedInputText.text($this.children('option').eq(0).text());
    var $arrow = jQuery('<span class="select-arrow"></span>');
    $styledSelect.append($selectedInputText);
    $styledSelect.append($arrow);
    var $list = jQuery('<ul />', {
      "class": 'select-options'
    }).insertAfter($styledSelect);
    for (var i = 0; i < numberOfOptions; i++) {
      jQuery('<li />', {
        text: $this.children('option').eq(i).text(),
        rel: $this.children('option').eq(i).val()
      }).appendTo($list);
    }
    var $listItems = $list.children('li');
    $styledSelect.click(function (e) {
      e.stopPropagation();
      jQuery(this).parent().toggleClass('active');
      jQuery(this).toggleClass('active');
      selectOptions = jQuery(this).next('ul.select-options');
      if (jQuery(this).parent().hasClass('active')) {
        selectOptions.css('display', 'flex');
      } else {
        selectOptions.hide();
      }
    });
    $listItems.click(function (e) {
      e.stopPropagation();
      selectedInput = true;
      $selectedInputText.text(jQuery(this).text()).parent().removeClass('active');
      $this.val(jQuery(this).attr('rel'));
      selectOptions.hide();
      jQuery('.js-select').removeClass('active');
      if (e.target && selectedInput) {
        jQuery(e.target).parent().prev().addClass('selected');
      }
    });
    jQuery(document).click(function (e) {
      var isSelect = function isSelect(e) {
        return e.target.nodeName === 'SELECT';
      };
      if (!isSelect(e)) {
        $styledSelect.removeClass('active');
        jQuery('.js-select').removeClass('active');
        $list.hide();
      }
    });
  });
}
export default select;